import { TimeEnum } from '@lib/enums';
import { ADJUSTMENT_ATOM_KEY_PREFIX } from '@states/adjustment/adjustmentAtom';
import { getDraftSavedAtKey } from '@states/drafts/draftSavedAt';
import { EQUITY_CALCULATION_ATOM_KEY_PREFIX } from '@states/equity/equityCalculationAtom';

const DRAFT_KEY_PREFIXES = [EQUITY_CALCULATION_ATOM_KEY_PREFIX, ADJUSTMENT_ATOM_KEY_PREFIX];

export function removeExpiredDrafts(): void {
  const now = Date.now();

  Array.from({ length: localStorage.length }, (_, index) => localStorage.key(index))
    .filter((key): key is string => key != null)
    .filter((key) => DRAFT_KEY_PREFIXES.some((prefix) => key.startsWith(prefix)))
    .forEach((draftKey) => {
      const savedAtKey = getDraftSavedAtKey(draftKey);
      const savedAt = localStorage.getItem(savedAtKey);

      if (savedAt == null) {
        localStorage.setItem(savedAtKey, String(now));
        return;
      }

      if (now - Number(savedAt) > TimeEnum.OneWeek) {
        localStorage.removeItem(draftKey);
        localStorage.removeItem(savedAtKey);
      }
    });
}
